export const LAST_SERVER_CONTACT_CONFIG_KEY = 'device.lastServerContactAt';
export const OFFLINE_LOCK_DAYS_CONFIG_KEY = 'device.offlineLockDays';
/** Days without contact before the till locks, when the server has not said. */
export const DEFAULT_OFFLINE_LOCK_DAYS = 7;
/** A clock this far behind the last contact is treated as wound back. */
const CLOCK_TOLERANCE_MS = 10 * 60_000;
const DAY_MS = 24 * 60 * 60 * 1000;
export async function recordServerContact(config, now = new Date()) {
    await config.set(LAST_SERVER_CONTACT_CONFIG_KEY, now.toISOString());
}
/** Records the server's setting, from a sync pull. */
export async function setOfflineLockDays(config, days) {
    if (!Number.isInteger(days) || days < 1)
        return;
    await config.set(OFFLINE_LOCK_DAYS_CONFIG_KEY, String(days));
}
export async function offlineLockDays(config) {
    const raw = await config.get(OFFLINE_LOCK_DAYS_CONFIG_KEY);
    const days = raw === null ? NaN : Number(raw);
    return Number.isInteger(days) && days >= 1 ? days : DEFAULT_OFFLINE_LOCK_DAYS;
}
/**
 * Whether the till is locked. A till with no contact recorded (set up
 * before this existed) is not locked; its next pull records one.
 */
export async function deviceContactState(config, now = new Date()) {
    const [raw, lockDays] = await Promise.all([config.get(LAST_SERVER_CONTACT_CONFIG_KEY), offlineLockDays(config)]);
    const last = raw === null ? NaN : Date.parse(raw);
    if (!raw || Number.isNaN(last))
        return { locked: false, lastContactAt: null, lockDays };
    if (now.getTime() < last - CLOCK_TOLERANCE_MS) {
        return { locked: true, reason: 'CLOCK_BEHIND', lastContactAt: raw, lockDays };
    }
    if (now.getTime() - last > lockDays * DAY_MS) {
        return { locked: true, reason: 'STALE', lastContactAt: raw, lockDays };
    }
    return { locked: false, lastContactAt: raw, lockDays };
}
//# sourceMappingURL=contact.js.map